/*
 * @Author: cn1994
 * @Date: 2024-06-05 17:45:16
 * @LastEditors: cn1994
 * @LastEditTime: 2024-07-11 15:47:47
 * @Description: 课时卡管理
 */
const routes = [
  {
    path: '/lessonCard',
    name: 'lessonCard',
    meta: {
      title: '课时卡管理',
      volcengine: true,
    },
    component: () => import('../pages/lessonCard/manage/index.vue'),
  },
  {
    path: '/lessonCard/create',
    name: 'lessonCard/create',
    meta: {
      title: '创建课时卡',
      volcengine: true,
    },
    component: () => import('../pages/lessonCard/manage/create.vue'),
  },
  {
    path: '/lessonCard/detail',
    name: 'lessonCard/detail',
    meta: {
      title: '课时卡详情',
      volcengine: true,
    },
    component: () => import('../pages/lessonCard/manage/components/lessonCardDetail.vue'),
  },
]
export default routes
